import BondsTable from "./BondsTable";
import UploadButton from "../../components/UploadButton";
import { useBonds } from "../../hooks/useBonds";
import type { Bond, BondsMetadata } from "../../types/bonds";
import { useState } from "react";

export default function BondsPage() {
  const { refetch } = useBonds();
  const [uploadedBonds, setUploadedBonds] = useState<Bond[] | null>(null);
  const [uploadedFileName, setUploadedFileName] = useState<string | null>(null);
  const [metadata, setMetadata] = useState<BondsMetadata | null>(null);

  const handleDataReceived = (newBonds: Bond[], fileName: string) => {
    // Pass the uploaded bonds and fileName to BondsTable
    setUploadedBonds(newBonds);
    setUploadedFileName(fileName);
  };

  const handleMetadataReceived = (newMetadata: BondsMetadata) => {
    setMetadata(newMetadata);
  };

  const handleRefreshFromAPI = () => {
    // Force refresh from API and clear uploaded bonds
    refetch();
    setUploadedBonds(null);
    setUploadedFileName(null);
  };

  const handlePageRefresh = () => {
    // Comprehensive page refresh after saving data
    // This will clear any uploaded bonds and refetch fresh data from the API
    setUploadedBonds(null);
    setUploadedFileName(null);
    refetch();
  };

  const formatDate = (dateString?: string) => {
    if (!dateString) return '-';
    try {
      return new Date(dateString).toLocaleString('pl-PL');
    } catch {
      return dateString;
    }
  };

  return (
    <div className="bonds-page">
      <div className="bonds-page-header">
        <h1>Zarządzanie obligacjami</h1>
        <div className="bonds-page-actions">
          {uploadedBonds && (
            <button
              onClick={handleRefreshFromAPI}
              className="refresh-api-button"
              title="Odśwież dane z API"
            >
              🔄 Odśwież z API
            </button>
          )}
          <UploadButton
            onDataReceived={handleDataReceived}
          />
        </div>
      </div>

      {metadata && (
        <div className="bonds-metadata">
          <div className="metadata-item">
            <span className="metadata-label">Ostatnia modyfikacja:</span>
            <span className="metadata-value">{formatDate(metadata.lastModifiedAt)}</span>
          </div>
          <div className="metadata-item">
            <span className="metadata-label">Ostatni wgrany plik:</span>
            <span className="metadata-value">{metadata.fileName || 'Brak'}</span>
          </div>
          <div className="metadata-item">
            <span className="metadata-label">Data wgrania:</span>
            <span className="metadata-value">{formatDate(metadata.lastFileUploadedAt)}</span>
          </div>
        </div>
      )}

      <BondsTable
        uploadedBonds={uploadedBonds}
        uploadedFileName={uploadedFileName}
        onPageRefresh={handlePageRefresh}
        onMetadataReceived={handleMetadataReceived}
      />
    </div>
  );
} 